import type { Permission as PermissionValue } from '@/types/generated';

export const Permission = {
    VIEW_USERS: 'view users',
    CREATE_USERS: 'create users',
    UPDATE_USERS: 'update users',
    DELETE_USERS: 'delete users',

    VIEW_ROLES: 'view roles',
    CREATE_ROLES: 'create roles',
    UPDATE_ROLES: 'update roles',
    DELETE_ROLES: 'delete roles',

    VIEW_FORMS: 'view forms',
    CREATE_FORMS: 'create forms',
    UPDATE_FORMS: 'update forms',
    DELETE_FORMS: 'delete forms',

    CREATE_FORMVERSIONS: 'create formversions',
    UPDATE_FORMVERSIONS: 'update formversions',

    VIEW_INVITES: 'view invites',
    CREATE_INVITES: 'create invites',
    UPDATE_INVITES: 'update invites',
    DELETE_INVITES: 'delete invites',
    IMPORT_INVITES: 'import invites',

    VIEW_DEBUG: 'view debug',
    VIEW_DEBUG_CDM: 'view debug cdm',
    VIEW_EXPLANATION: 'view explanation',
    VIEW_TABLES: 'view tables',
    VIEW_DRD: 'view drd',

    EXPORT_EXCEL: 'export excel',
    EXPORT_INVITES: 'export invites',
    VIEW_IMPORTS: 'view imports',
    CREATE_IMPORTS: 'create imports',
    EXPORT_BATCH: 'export batch',

    VIEW_FILES: 'view files',
    CREATE_FILES: 'create files',

    VIEW_SETTINGS: 'view settings',
    UPDATE_SETTINGS: 'update settings',
    EXPORT_INIT_FILE: 'export init file',

    VIEW_FORMGROUPS: 'view formgroups',
    CREATE_FORMGROUPS: 'create formgroups',
    UPDATE_FORMGROUPS: 'update formgroups',
    DELETE_FORMGROUPS: 'delete formgroups',

    VIEW_AUDITLOG: 'view auditlog',

    VIEW_DOCS: 'view docs',
} as const satisfies Record<string, PermissionValue>;

export type Permission = PermissionValue;
